import { render, staticRenderFns } from "./PromocodesPage.vue?vue&type=template&id=1cb26c98&scoped=true&"
import script from "./PromocodesPage.vue?vue&type=script&lang=js&"
export * from "./PromocodesPage.vue?vue&type=script&lang=js&"
import style0 from "./PromocodesPage.vue?vue&type=style&index=0&id=1cb26c98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb26c98",
  null
  
)

export default component.exports